import React from 'react'
import {useRouter} from 'next/router'
import {Button} from 'src/Button'
import {Modal} from '@components/Modal.jsx'
import {ButtonGroup} from 'src/Common'
import {VStack} from '@components/Stack'
import styles from 'src/Learn.module.css'

const StartLearnModal = ({isOpen, link, onRequestClose}) => {
  const router = useRouter()

  return (
    <Modal isOpen={isOpen} extraClasses="modal--text-center">
      <VStack gap="1rem" align="stretch">
        <h2 style={{fontSize: '2rem', color: 'var(--clr-brand'}}>
          Get . Set . Learn!
        </h2>
        <p className="para" style={{lineHeight: '1.6'}}>
          CSSBattle's LEARN is not just a course, its an experience! Its meant
          to be done in a serene ambience.
        </p>

        <ol
          style={{
            textAlign: 'left',
            padding: 0,
            display: 'flex',
            gap: '2rem',
          }}
        >
          <li className={styles.startModalListItem}>
            <span>🔅</span>Dim your lights a bit
          </li>
          <li className={styles.startModalListItem}>
            <span>🔊</span>Turn up your volume
          </li>
          <li className={styles.startModalListItem}>
            <span>😌</span>Relax!
          </li>
        </ol>

        <ButtonGroup center>
          <Button onClick={onRequestClose}>Cancel</Button>

          <Button cool onClick={() => router.push(link)}>
            LET'S LEARN!
            <svg
              style={{
                marginLeft: '0.5rem',
                width: '30px',
                height: '30px',
                fill: 'currentcolor',
                filter: 'drop-shadow(0px 26px 8px rgba(0,0,0,0.4))',
              }}
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
            </svg>
          </Button>
        </ButtonGroup>
      </VStack>
    </Modal>
  )
}

export {StartLearnModal}
